import '../styles/lifepal.css';

import { Link } from 'gatsby';
import React from 'react';

function HomePal() {

	return(
		<p>Finding the right homeowner insurance can be confusing, but Bubble HomePal<sup>TM</sup> is here to help! It uses the power of AI to simplify the insurance shopping process and ensure you get the coverage you need.

			<br/>

        Here's how Bubble HomePal<sup>TM</sup> makes finding home insurance easy:

			<br/>

			<ol className='lifepal-list'>
				<li><strong>Understand your risks</strong>: Identifies potential threats to your home, its belongings and occupants, like fires, floods, or theft, based on your neighborhood.</li>

				<li><strong>See what others experience</strong>: Provides insights into the most common and expensive insurance claims in your area.</li>

				<li><strong>Find the perfect fit</strong>: Matches your home with recommended insurance policies and optional coverages (called riders or endorsements) that address your specific needs.</li>

				<li><strong>Prevent future problems</strong>: Bubble HomePal

					<sup>TM</sup> even suggests preventive safety measures to help you mitigate future damages from hazards and avoid claims to begin with (which helps keep your premiums low)!</li>

			</ol>

			<p className='homepal'>With Bubble HomePal<sup><strong className='txtbold'>TM</strong></sup>, finding the right home insurance is a breeze.

				<span className='go-there'> <Link onClick={() => {
					window.location.href = '/';
				}} to="/"> Get started today! </Link></span> </p>

		</p>
	);
}

export default HomePal;
